module.exports = __webpack_public_path__ + "static/media/empty-state-folder.789d58db.png";